<template>
<q-modal :content-css="{ width: '80vw', height: '80vh' }" v-model="showDlg" no-backdrop-dismiss	@show="loadLogs()">
  <q-modal-layout>
    <q-toolbar slot="header">
      <q-toolbar-title>
        {{$t('logtitle')}} "{{ uuid }}"
      </q-toolbar-title>
      <q-btn
        flat
        round
        @click="closeDlg"
        icon="close"
      />
    </q-toolbar>

    <q-toolbar slot="footer">
      <q-toolbar-title>
      </q-toolbar-title>
      <q-btn
        color="secondary"
        :label="$t('closebtn')"
        @click="closeDlg"
      />
    </q-toolbar>

    <div class="doc-container q-ma-sm">
      <q-table
        color="primary"
        :data="data"
        :columns="columns"
        row-key="number"
        :pagination.sync="pagination"
        dense
      >
      <template slot="body" slot-scope="props">
        <q-tr :props="props">
          <q-td key="number" :props="props">
            {{ props.row.__index + 1 }}
          </q-td>

          <q-td key="created" :props="props">
            {{ props.row.created | datetimeformat }}
          </q-td>

          <q-td key="sent" :props="props">
            {{ props.row.sent | datetimeformat }}              
          </q-td>

          <q-td key="note" :props="props">
            <template v-if="props.row.note.length > 100">
              <q-tooltip>{{ props.row.note }}</q-tooltip>
            </template>
            {{ props.row.note | truncate(100,'...')}}                            
          </q-td>

          <q-td key="state" :props="props">
            {{ props.row.state }}                                          
          </q-td>

          <q-td key="answered" :props="props">
            {{ props.row.answered | datetimeformat }}                                          
          </q-td>

        </q-tr>
      </template>          
    </q-table>
    </div>
  </q-modal-layout>
</q-modal></template>

<script>

import axios from 'axios'

export default {
  data () {
    return {
      pagination: {
        sortBy: null, 
        descending: false,
        page: 1,
        rowsPerPage: 20 
      },
      columns: [
        { name: 'number', label: '№', field: 'number', align: 'center',  },
        { name: 'created', label: this.$t('columns.created'), field: 'created', align: 'center',  },
        { name: 'sent', label: this.$t('columns.sent'), field: 'sent', align: 'center',  },
        { name: 'note', label: this.$t('columns.note'), field: 'note', align: 'left',  },
        { name: 'state', label: this.$t('columns.statelog'), field: 'state', align: 'center',  },
        { name: 'answered', label: this.$t('columns.answered'), field: 'answered', align: 'center',  },
      ],
      data: []
    }
  },

  props: {
    showDlg: null,
    uuid: null,
  },     

  methods:
  {
    loadLogs: function()
    {
      axios.get(`${this.$root.api_url}device/${this.uuid}/log/`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'JWT ' + this.$store.state.token
        }
        }).then(({ data }) => {
          this.data = data
        //console.log(data)
      })
      .catch (e =>{
        // eslint-disable-next-line
        console.log(e.response.data)
        switch (e.response.status) {
          case 401: this.$router.push('/auth'); break
          default: this.$q.notify({message: this.$t('error') + ': ' + e.response.statusText, type: 'negative', icon: 'report_problem' }); break
        }
      })
    },
    closeDlg:function()
    {
      this.$emit('closeLogsDlg');
    }
  },
  components: {  }

}
</script>

<style scoped>
table th td {
    word-break: break-all;
}
</style>
